import React from 'react';

const Settings = () => {
  return (
    <div style={{ padding: '20px', borderRadius: '10px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
      <h3>System Settings</h3>
      <p>Configure the preferences for the system.</p>
      <form>
        <label>
          <span>Enable Notifications</span>
          <input type="checkbox" />
        </label>
        <br />
        <label>
          <span>Language:</span>
          <select>
            <option value="en">English</option>
            <option value="es">Spanish</option>
          </select>
        </label>
        <br />
        <button style={{ backgroundColor: '#fb9678', color: '#fff', border: 'none', padding: '10px 15px', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}>Save Settings</button>
      </form>
    </div>
  );
};

export default Settings;
